import React, { useState } from 'react';
import { TagIcon, CopyIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { discountOffer } from '../data/product';
import { trackCustom } from '../utils/tracking';
const REDIRECT_URL = 'https://gritvuegear.com';
export function DiscountSection() {
  const [copied, setCopied] = useState(false);

  // Copies the code, shows "Copied" for a beat, then sends the visitor to gritvuegear.com.
  const handleCopy = () => {
    trackCustom('discount_code_copied', {
      code: discountOffer.code
    });
    if (navigator.clipboard) {
      navigator.clipboard.writeText(discountOffer.code).catch(() => undefined);
    }
    setCopied(true);
    window.setTimeout(() => {
      window.location.href = REDIRECT_URL;
    }, 600);
  };
  return <section aria-labelledby="discount-heading" className="border-b border-white/10 bg-grit-500" data-id="element-501" data-mp="1hftqe66bfdfe">
      <div className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-id="element-502" data-mp="tppny24v5jpz">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-14" data-id="element-503" data-mp="orxv95we9tkq">
          <div data-id="element-504" data-mp="2hfx7i9prcmdt">
            <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.3em] text-ink-950/70" data-id="element-505" data-mp="2hecewpn07dil">
              <TagIcon className="h-4 w-4" aria-hidden="true" data-id="element-506" data-mp="2r68btxdcsxl8" />
              {discountOffer.eyebrow}
            </p>
            <h2 id="discount-heading" className="grit-headline mt-3 text-[clamp(2.5rem,9vw,5rem)] font-extrabold uppercase text-ink-950" data-id="element-507" data-mp="2v8d3wro5lm5r">
              5 off your first X1.
            </h2>
            <p className="mt-3 max-w-xl text-[15px] font-medium text-ink-950/80 sm:text-base" data-id="element-508" data-mp="23hgpvnqcxbgw">
              {discountOffer.body}
            </p>
          </div>

          <div className="w-full max-w-md shrink-0 bg-ink-950 p-6" data-id="element-509" data-mp="2ch3vklq4d3fr">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-510" data-mp="2cf98b0rdkz8i">Your code</p>
            <div className="mt-3 flex items-center justify-between gap-4 border-2 border-dashed border-grit-500 px-4 py-3" data-id="element-511" data-mp="3izsaiwmyqpmt">
              <span className="font-display text-4xl font-extrabold uppercase tracking-[0.12em] text-grit-500" data-id="element-512" data-mp="1ntznw0zekxfw">
                {discountOffer.code}
              </span>
              <button type="button" onClick={handleCopy} className="inline-flex shrink-0 items-center gap-2 bg-grit-500 px-4 py-2.5 font-display text-base font-extrabold uppercase text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px]" data-id="element-513" data-mp="1juqtqv0gaxjt">
                {copied ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-514" data-mp="102lvjv1951ux" /> : <CopyIcon className="h-4 w-4" aria-hidden="true" data-id="element-515" data-mp="1euw40usewe0c" />}
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>

            <a href={REDIRECT_URL} data-buy-intent="true" onClick={event => {
            event.preventDefault();
            handleCopy();
          }} className="group mt-5 flex w-full items-center justify-center gap-3 bg-grit-500 px-6 py-4 font-display text-2xl font-extrabold uppercase tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px]" data-id="element-516" data-mp="mc8pxzbu1z8r">
              {discountOffer.cta}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-517" data-mp="2o03f0jdcdheq" />
            </a>
            <p className="mt-3 text-[12px] text-steel-500" data-id="element-518" data-mp="3gor6wxslj519">{discountOffer.note}</p>
          </div>
        </div>
      </div>
    </section>;
}